import { defineMessages } from 'react-intl';

const messages = defineMessages({
    advancedContentInsightsTitleEnabled: {
        defaultMessage: 'Engagement Insights is activated',
        description: 'Advanced Content Insights toggle title',
        id: 'boxui.advancedContentInsights.advancedContentInsightsTitleEnabled',
    },
    advancedContentInsightsTitleDisabled: {
        defaultMessage: 'Activate Engagement Insights',
        description: 'Advanced Content Insights toggle title',
        id: 'boxui.advancedContentInsights.advancedContentInsightsTitleDisabled',
    },
    advancedContentInsightsDescription: {
        defaultMessage:
            'Get actionable insights into how viewers are engaging with this content. Measure average time spent, page-by-page engagement, per person and per visit details.',
        description: 'Description text about advanced content insights.',
        id: 'boxui.advancedContentInsights.advancedContentInsightsDescription',
    },
});

export default messages;
